module.exports = __webpack_public_path__ + "img/default_image.968f4254.svg";